import { OPEN_PROVIDER_MENU } from '../constants/EventListeners';
export function triggerHostMessageOpenProviderMenu() {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: OPEN_PROVIDER_MENU
    });
  }
}